import { useState } from 'react';
import { FAIcon, useTranslation } from '@nextgen-web-framework/all';
import { type AppState, StorageService } from '@nextgen-web-framework/core';
import {
  type Cart,
  CartConstantsEnum,
  cartApi,
  updateCart,
  type InitialCartState,
  OrderType,
} from '@commerce-cart-webcomponents/sdk';
import { useDispatch, useSelector } from 'react-redux';
import { AmwayUserDetails } from '@commerce-cart-webcomponents/sdk/services/models/AmwayUserDetails';
import { AccountSearchDrawer } from '../../common/components/account-search-drawer/AccountSearchDrawer';
import { CartNotificationTheme, TOAST_TIMEOUT, useCartNotification } from '../../common';
import styles from './AddSubCartIcon.module.scss';

export const AddSubCartIcon = () => {
  const dispatch = useDispatch();
  const t = useTranslation();
  const [showAccountDrawer, setShowAccountDrawer] = useState(false);
  const commerceCartState = useSelector((state: AppState) => state.commerceCart);
  const { cart }: InitialCartState = commerceCartState;
  const { createToast, deleteToast } = useCartNotification('addSubCartIcon');
  const newCartCreatedText = t('cart.addSubCartIcon.newCartCreated');
  const drawerHeaderTitle = t('cart.addSubCartIcon.drawerHeaderTitle');
  const placeHolderText = t('cart.addToCartDrawer.placeHolderText');
  const accountCancelText = t('cart.addToCartDrawer.accountCancel');
  const accountAddCartText = t('cart.addToCartDrawer.accountAddCart');

  function handleDrawerClose() {
    setShowAccountDrawer(false);
  }

  function handleAddCart(profile: AmwayUserDetails) {
    const payload = {
      version: Number(StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartReqVersion)),
      orderType: OrderType.Gco,
      entries: [],
      amwayUser: {
        amwayUserId: profile?.amwayUserId as string,
        accountId: profile?.accountId,
      },
    };

    cartApi
      .createSubCart({
        cartId: StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartId),
        payload,
      })
      .then((res) => {
        dispatch(updateCart(res as Cart));
        setShowAccountDrawer(false);
        createToast(
          {
            theme: CartNotificationTheme.SUCCESS,
            rightSeperator: false,
            content: newCartCreatedText,
            clickIcon: 'times',
            icon: 'check-circle',
            timeOut: TOAST_TIMEOUT,
          },
          deleteToast,
        );
      });
  }
  return (
    <>
      <FAIcon className={styles['add-sub-cart-icon']} iconName="plus" onClick={() => setShowAccountDrawer(true)} />
      {showAccountDrawer && (
        <AccountSearchDrawer
          cartData={cart}
          onPrimaryButtonClick={handleDrawerClose}
          drawerHeaderTitle={drawerHeaderTitle}
          placeHolderText={placeHolderText}
          primaryButtonText={accountCancelText}
          secondaryButtonText={accountAddCartText}
          onRadioChange={handleAddCart}
        />
      )}
    </>
  );
};
